import { useParams } from "react-router-dom";
import useDatasetTablesSearch from "datasets/pages/tables/hooks/useDatasetTablesSearch";
import DatasetTableResponse from "datasets/pages/tables/types/interfaces/table";
import queryString from "query-string";
import { SWRResponse } from "swr";
import { useQueryParams, withDefault, NumberParam } from "use-query-params";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

export const PAGE_SIZE = 10;

const useDatasetTables = (searchTerm: string = ""): SWRResponse<DatasetTableResponse[]> => {
  const { datasetId } = useParams();
  const getUnfilteredList = Boolean(datasetId && !searchTerm);
  const [query] = useQueryParams({
    perPage: withDefault(NumberParam, PAGE_SIZE),
    page: withDefault(NumberParam, 0),
  });

  const { page, perPage } = query;

  const qs = queryString.stringify({
    limit: perPage,
    offset: page ? (page - 1) * perPage : 0,
  });

  const listResp = useFetcher<DatasetTableResponse[]>(
    getUnfilteredList ? `${VITE_CATALOG_API}/tables/dataset/${datasetId}?${qs}` : null
  );

  const searchResp = useDatasetTablesSearch(searchTerm);

  if (getUnfilteredList) {
    return listResp;
  }

  return searchResp;
};

export default useDatasetTables;
